import { Calendar } from "../calendar";
import { Snakify } from "../snakify";

export enum AvailabilityMode {
  TimeRule = "time_rule",
  Within = "within",
  PerWeek = "per_week",
  PerMonth = "per_month"
}

export enum DurationMode {
  Days = "days",
  Hours = "minutes"
}

export type AvailabilityDuration = {
  mode: DurationMode;
  value: number;
};

type BaseRange = {
  start: string | null;
  end: string | null;
  phaseSourceId?: string;
};

type _TimeRuleRange = BaseRange & {
  dayOfWeek: number[];
};
export type TimeRuleRange = Snakify<_TimeRuleRange>;

type _StandardRange = BaseRange & {
  duration: AvailabilityDuration;
};
export type StandardRange = Snakify<_StandardRange>;

type _AvailabilityRange = _TimeRuleRange | _StandardRange;
export type AvailabilityRange = TimeRuleRange | StandardRange;

export type AvailabilityRule = Snakify<{
  mode: AvailabilityMode;
  availabilityThreshold: number;
  ranges: _AvailabilityRange[];
}>;

export interface ProfileAvailability {
  calendars?: { [key: string]: Calendar };
}

export type Availability = AvailabilityRange | AvailabilityRule | ProfileAvailability;

export type ProfileDayAvailability = {
  id: number;
  date: string;
  availableMinutes: number;
  nominalWorkingMinutes: number;
  billableUtilization: number;
  utilization: number;
};

export type DateRange = {
  min: string;
  max: string;
};
